import { Get } from "../../utils/apiUtils";

export const getAllKpis = async (req: any): Promise<any> => {
    return await Get('/kpi/', { msgKey: 'dashboard' });
}